import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {CellPropsType} from './cellPropsType'
import {useAppDispatch} from 'redux/config'
import {select_jobTypeActionOptions} from 'redux/jobs/selectors'
import {Icon, Link, Tooltip, Stack} from '@mdsol/onex-design'

import './actions.scss'
import {downloadJobReport, downloadDataVerificationHashJson} from 'redux/jobs/jobs.duck'
import {ActionType, JobType, DataVerificationHashTask} from 'api/graphQL/generated/graphql'

const ActionsCell: FC<CellPropsType> = ({cell}) => {
  const {sumoLogicTraceLink, grafanaTraceLink, jobId, jobType, status, tasks} = cell.row.original
  const dispatch = useAppDispatch()

  const jobTypeActionOptions = useSelector(select_jobTypeActionOptions)
  const DownloadReportIcon = jobTypeActionOptions?.find(opt => opt.actionType === ActionType.Report)?.icon
  
  const isDataVerificationHasherWithJsonFile = jobType === JobType.DataVerificationHasher && 
    tasks?.length === 1 && 
    (tasks[0] as DataVerificationHashTask)?.createJsonFile === true
  
  const isDownloadReportDisabled = jobType === JobType.DataVerificationHasher 
    ? !isDataVerificationHasherWithJsonFile
    : !jobTypeActionOptions?.find(opt =>
      opt.actionType === ActionType.Report &&
      opt.configuration?.some(config =>
        config.jobType === jobType && config.jobStatus.includes(status)
      )
    )
  const SumoLogicTraceLinkIcon = jobTypeActionOptions?.find(opt => opt.actionType === ActionType.Log)?.icon
  const GrafanaTraceLinkIcon = jobTypeActionOptions?.find(opt => opt.actionType === ActionType.Trace)?.icon

  const handleDownloadReport = () => {
    if (isDataVerificationHasherWithJsonFile) {
      dispatch(downloadDataVerificationHashJson(jobId))
    } else {
      dispatch(downloadJobReport(jobId))
    }
  }

  return (
    <>
      <Stack
        direction='horizontal'
        gap={3}
      >
        {sumoLogicTraceLink ?
          <Tooltip
            id='sumo-logic-link-tooltip'
            tooltipChildren='Go to sumo logs'
            placement='bottom'
          >
            <Link
              dataTestId='sumo-logic-trace-link'
              targetBlank
              href={sumoLogicTraceLink}
              leadingIcon={<Icon key='sumo-logic-trace-link-icon-key'>{SumoLogicTraceLinkIcon}</Icon>}
            >
            </Link>
          </Tooltip> : <div></div>
        }
        {grafanaTraceLink ?
          <Tooltip
            id='grafana-trace-link-tooltip'
            tooltipChildren='Go to grafana tracing'
            placement='bottom-start'
          >
            <Link
              dataTestId='grafana-trace-link'
              targetBlank
              href={grafanaTraceLink}
              leadingIcon={<Icon key='grafana-trace-link-icon-key'>{GrafanaTraceLinkIcon}</Icon>}
            >
            </Link>
          </Tooltip> : <div></div>
        }
        <Tooltip
          id='download-report-link-tooltip'
          tooltipChildren='Download Report'
          placement='bottom-start'
        >
          <Link
            dataTestId='download-report-link'
            targetBlank
            leadingIcon={<Icon key='file-download-link-icon-key'>{DownloadReportIcon}</Icon>}
            onClick={handleDownloadReport}
            disabled={isDownloadReportDisabled}
          >
          </Link>
        </Tooltip>
      </Stack>
    </>
  )
}

export default ActionsCell
